import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson27: FunctionComponent = () => {
  return (
    <div className="relative [background:linear-gradient(111.77deg,_rgba(0,_0,_0,_0),_#363636_78.54%),_#0d0d0d] w-full overflow-hidden flex flex-col items-center justify-center pt-[2.69rem] px-[2.69rem] pb-[7.63rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV dimensionCode="/nav@2x.png" navIconFlexShrink="unset" />
      <div className="self-stretch flex flex-row items-center justify-between">
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson26"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Back
          </b>
        </div>
        </a>
        <div className="self-stretch flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[100%]">Stretching</b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson28"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Next
          </b>
        </div>
        </a>
      </div>
      <div className="w-full flex flex-col items-center justify-center gap-[9.63rem] max-w-[125rem] text-white font-dm-sans">
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-justify text-[1.88rem]">
          <p className="m-0">
            <b>
              <span>Introduction to Stretching</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Stretching is a vital component of physical fitness and overall
                health. It can improve flexibility, increase range of motion,
                enhance muscular performance, and reduce the risk of injury.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Incorporating a regular stretching routine can also help relieve
                stress and provide a mental break.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-justify">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>
                <span>Benefits of Stretching</span>
              </span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>
                <span>&nbsp;</span>
              </b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b>Enhanced Flexibility:</b>
                  <span>
                    {" "}
                    Regular stretching can lead to increased flexibility, which
                    can improve your performance in physical activities.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">{`Improved Posture: `}</b>
                  <span>
                    Stretching the muscles of the lower back, shoulders, and
                    chest can help keep the back in better alignment and improve
                    posture.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Injury Prevention:</b>
                  <span>
                    {" "}
                    Flexible muscles are less likely to become injured from a
                    slightly extensive movement.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b>Increased Nutrients:</b>
                  <span>
                    {" "}
                    Stretching increases blood supply to the muscles and joints,
                    which can provide greater nutrient transportation and
                    improve the circulation of blood through the entire body.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">{`Reduced Muscle Soreness: `}</b>
                  <span>
                    Stretching before and after a workout gives your muscles
                    time to relax.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li>
              <span>
                <span>
                  <b className="font-dm-sans">{`Stress Relief: `}</b>
                  <span>
                    Stretching exercises have powerful stress-relieving
                    abilities. They relax tight, tense muscles that often
                    accompany stress.
                  </span>
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-justify">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>Stretching Schedule</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  A balanced stretching schedule should include stretches for
                  all major muscle groups and should be performed at least 3 to
                  5 times a week. Here’s a sample weekly schedule:
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Monday, Wednesday, Friday:</b>
                  <span> Full-body stretching routine</span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Tuesday, Thursday:</b>
                  <span>
                    {" "}
                    Targeted stretching focusing on areas that are sore or were
                    heavily used in previous days' workouts
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li>
              <span>
                <span>
                  <b className="font-dm-sans">Saturday, Sunday:</b>
                  <span>
                    {" "}
                    Gentle stretching and yoga to recover and maintain
                    flexibility
                  </span>
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-justify text-[1.88rem]">
          <p className="m-0">
            <b>
              <span>Stretching Exercises</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Here is a set of exercises targeting all major muscle groups:
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-[1.88rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>
                  <span>Upper Body Stretches</span>
                </span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>
                  <span>&nbsp;</span>
                </b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  <b>Neck Stretch:</b>
                  <span>
                    {" "}
                    Gently tilt your head to one side, holding for 20-30
                    seconds. Repeat on the other side.
                  </span>
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[20.81rem] object-cover"
            alt=""
            src="/48@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-gainsboro-100">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <b>{`Shoulder Stretch: `}</b>
            <span>
              Bring one arm across your body, holding it with the other arm for
              20-30 seconds. Repeat with the opposite arm.
            </span>
          </div>
          <img
            className="relative w-[34.63rem] h-[19.44rem] object-cover"
            alt=""
            src="/49@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-gainsboro-100">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <b>Triceps Stretch:</b>
            <span>
              {" "}
              Reach one arm overhead, bend at the elbow, and gently push on the
              elbow with the opposite hand. Hold for 20-30 seconds and switch
              arms.
            </span>
          </div>
          <img
            className="relative w-[34.63rem] h-[22rem] object-cover"
            alt=""
            src="/50@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-gainsboro-100">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <b>{`Chest Stretch: `}</b>
            <span>
              Stand in a doorway with your arms on the door frame and gently
              lean forward until you feel a stretch in your chest. Hold for
              20-30 seconds.
            </span>
          </div>
          <img
            className="relative w-[34.63rem] h-[20rem] object-cover"
            alt=""
            src="/51@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-[1.88rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>
                  <span>Core and Back Stretches</span>
                </span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>
                  <span>&nbsp;</span>
                </b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  <b>{`Cat-Cow Stretch: `}</b>
                  <span>
                    On your hands and knees, alternate between arching your back
                    towards the ceiling and dipping it towards the floor.
                  </span>
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[26.94rem] object-cover"
            alt=""
            src="/52@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-gainsboro-100">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <b>Seated Twist:</b>
            <span>
              {" "}
              Sit with legs extended, cross one leg over the other, and twist
              towards the top leg, holding for 20-30 seconds. Repeat on the
              other side.
            </span>
          </div>
          <img
            className="relative w-[34.63rem] h-[26.94rem] object-cover"
            alt=""
            src="/53@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-gainsboro-100">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <b>{`Child’s Pose: `}</b>
            <span>
              Sit back on your heels with your arms extended forward on the
              floor, resting your forehead on the mat.
            </span>
          </div>
          <img
            className="relative w-[34.63rem] h-[18.5rem] object-cover"
            alt=""
            src="/54@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-[1.88rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>
                  <span>Lower Body Stretches</span>
                </span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>
                  <span>&nbsp;</span>
                </b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  <b>Hamstring Stretch:</b>
                  <span>
                    {" "}
                    Sit on the floor with one leg extended and the other tucked
                    in. Lean forward towards your foot. Hold for 20-30 seconds
                    and switch legs.
                  </span>
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[20.63rem] object-cover"
            alt=""
            src="/55@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-gainsboro-100">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <b>{`Quadriceps Stretch: `}</b>
            <span>
              While standing, pull one foot towards your buttocks, keeping knees
              together. Hold for 20-30 seconds and switch legs.
            </span>
          </div>
          <img
            className="relative w-[34.63rem] h-[32.75rem] object-cover"
            alt=""
            src="/56@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-gainsboro-100">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <b>{`Calf Stretch: `}</b>
            <span>
              Stand facing a wall with one foot in front of the other. Bend the
              front knee while keeping the back leg straight, and push against
              the wall. Hold for 20-30 seconds and switch legs.
            </span>
          </div>
          <img
            className="relative w-[34.63rem] h-[40.13rem] object-cover"
            alt=""
            src="/57@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-gainsboro-100">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <b>{`Hip Flexor Stretch: `}</b>
            <span>
              In a lunge position with one knee on the ground, push your hips
              forward. Hold for 20-30 seconds and switch sides.
            </span>
          </div>
          <img
            className="relative w-[34.63rem] h-[32.75rem] object-cover"
            alt=""
            src="/58@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-[1.88rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>
                  <span>Full Body Stretch</span>
                </span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>
                  <span>&nbsp;</span>
                </b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  <b>{`Standing Forward Bend: `}</b>
                  <span>
                    Stand with feet hip-width apart, bend forward at the hips,
                    and try to touch your toes. Hold for 30 seconds.
                  </span>
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[21.63rem] object-cover"
            alt=""
            src="/59@2x.png"
          />
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-justify">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>
                <span>Tips for Effective Stretching</span>
              </span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>
                <span>&nbsp;</span>
              </b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b>Warm Up:</b>
                  <span>
                    {" "}
                    Engage in 5-10 minutes of light aerobic exercise before
                    stretching to warm up your muscles.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">No Bouncing:</b>
                  <span>
                    {" "}
                    Stretch in a smooth movement without bouncing, which can
                    cause muscle strain.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Breathe Normally:</b>
                  <span>
                    {" "}
                    Do not hold your breath while stretching. Breathe freely and
                    deeply during the stretches.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b>Consistency:</b>
                  <span> Stretch regularly for the best results.</span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li>
              <span>
                <span>
                  <b>{`Don't Overdo It: `}</b>
                  <span>
                    Stretch to the point of mild discomfort, not pain.
                    Overstretching can cause damage to muscles and tendons.
                  </span>
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-justify text-[1.88rem]">
          <p className="m-0">
            <b>
              <span>Mindful Stretching</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Incorporate mindfulness into your stretching routine by paying
                attention to your breathing and the sensations in your body.
                This practice can enhance the stress-relieving benefits of your
                stretching session.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-justify text-[1.88rem]">
          <p className="m-0">
            <b>
              <span>Tracking Progress</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Keep a stretching journal to track your progress. Note which
                stretches you've done and any increase in flexibility. Over
                time, you should see improvements in your range of motion and
                how your body feels during and after workouts.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                By following this guide and integrating stretching into your
              </span>
            </span>
          </p>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson28"}>
        <div className="rounded-32xl bg-gainsboro-200 box-border w-[25rem] flex flex-col items-center justify-center pt-[0.69rem] px-[3rem] pb-[1rem] max-w-[31.25rem] text-center text-[1.88rem] border-[1px] border-solid border-gray-300">
          <b className="self-stretch relative">Next Chapter</b>
        </div>
      </a>
      </div>
    </div>
  );
};

export default Lesson27;
